import React from 'react'
import { CCard, CCardBody, CBadge } from '@coreui/react-pro'

const CommunityWinnerModal = ({ item }) => {
  const { payload } = item

  if (!payload) return <p>No data available</p>

  return (
    <div>
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h1 style={{ fontSize: '48px', marginBottom: '10px' }}>🏆</h1>
        <h5>Tournament Winner</h5>
        <CBadge color="warning">WINNER</CBadge>
      </div>

      <CCard style={{ marginBottom: '15px' }}>
        <CCardBody>
          <div style={{ marginBottom: '12px' }}>
            <strong>Champion:</strong> {payload.full_name || 'N/A'}
          </div>
          <div style={{ marginBottom: '12px' }}>
            <strong>Team:</strong> {payload.team_name || 'N/A'}
          </div>
          <div style={{ marginBottom: '12px' }}>
            <strong>Overall Points:</strong>{' '}
            <CBadge color="info">{payload.overall_points || 0}</CBadge>
          </div>
          <div style={{ marginBottom: '12px' }}>
            <strong>Overall Rank:</strong>{' '}
            <CBadge color="success">#{payload.overall_rank || 1}</CBadge>
          </div>
          {payload.final_score && (
            <div>
              <strong>Final Score:</strong> {payload.final_score}
            </div>
          )}
        </CCardBody>
      </CCard>
    </div>
  )
}

export default CommunityWinnerModal
